import { useState } from "react";
import { BsGear } from "../../assets/icons/vander";
import { DoctorLayout } from "../layout";
import { TopHeader } from "../components/utils";
import { DoctorPersonalForm, DoctorSecurityForm } from "../components/forms";

export const ProfilePage = () => {
  const [activeIndex, setActiveIndex] = useState(1);

  const Nav = () => (
    <nav aria-label="breadcrumb" className="d-inline-block">
      <ul className="breadcrumb bg-transparent rounded mb-0 p-0">
        <li className="breadcrumb-item active" aria-current="page">
          <BsGear className="icons-sm" /> Configuración
        </li>
      </ul>
    </nav>
  );

  return (
    <DoctorLayout>
      <TopHeader Nav={Nav} />
      <div className="vstack gap-4">
        <h1 className="mb-0">Configuración</h1>
        <div className="" style={{ maxWidth: "720px" }}>
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <button
                className={`nav-link ${activeIndex === 1 ? "active" : ""}`}
                onClick={() => setActiveIndex(1)}
                type="button"
              >
                Editar perfil
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeIndex === 2 ? "active" : ""}`}
                onClick={() => setActiveIndex(2)}
                type="button"
              >
                Seguridad
              </button>
            </li>
          </ul>

          <div className="card">
            <div className="card-body">
              {activeIndex === 1 && <DoctorPersonalForm />}
              {activeIndex === 2 && <DoctorSecurityForm />}
            </div>
          </div>
        </div>
      </div>
    </DoctorLayout>
  );
};
